const animations = () => {
  // Super simple way to set a parent container as "loaded" when a child element loads
  window.elementLoaded = (element) => {
    const parent = element.closest('.AnimateOnLoad');
    if (parent) {
      parent.classList.add('Animate');
      parent.classList.remove('AnimateOnLoad');
    }
    window.dispatchEvent(new Event('scroll'));
  };

  // Check for any "preloaded" images and basically do the same thing as the elementLoaded function above.
  // These are images that loaded before this JS file could even execute, which are handled by some inline JS in theme.liquid
  document.querySelectorAll('.AnimateOnLoad--preloaded').forEach((element) => {
    const parent = element.closest('.AnimateOnLoad');
    if (parent) {
      parent.classList.add('Animate');
      parent.classList.remove('AnimateOnLoad');
    }
  });

  window.addEventListener('scroll', () => {
    const scrollTop = window.scrollY;
    const windowHeight = window.innerHeight;
    const trigger = windowHeight * 0.9 + scrollTop;
    let delay = 0;

    /**
     * SILKY SMOOTH ANIMATION DELAYS :)
     * Delays are now coming from CSS animation-delay rather than setTimeouts.
     *
     * setTimeout is the MINIMUM time that must pass until your JS is put in the queue of the event loop.
     * So if a bunch of other shit is going on (like during page load) you might see your "50ms" delays do something like this:
     * 50ms, 210ms, 250ms, 250ms, 250ms
     *
     * Instead of this:
     * 50ms, 100ms, 150ms, 200ms, 250ms
     *
     * Note that this solution is by no means perfect. If you scroll extremely fast, you may have a few items on your screen that are
     * "new" so they start over with 0ms delays and animate in before the last few items above them have animated.
     * That said, you have to be doing some pretty stupid type of scrolling and it doesn't look terrible when it happens.
     **/

    document
      .querySelectorAll('.Animate:not(.Animate--animated), .Animate-when-loaded:not(.Animate--animated)')
      .forEach((element) => {
        const elementOffsetTop = element.getBoundingClientRect().top + scrollTop;
        const elementHeight = element.offsetHeight;

        if (elementOffsetTop + elementHeight < scrollTop) {
          // This item is above the viewable screen, animate it immediately and don't delay
          // We don't want to wait for our in-view items to show up if we reload a page half-way scrolled down.
          // Previously, all of the items above the viewable screen would add a 50ms delay each and you could be waiting 2-3 seconds
          // for all of those things to animate before the ones you can actually see would begin animating in.
          element.style.animationDelay = '0ms';
          element.style.transitionDelay = '0ms';
          element.classList.add('Animate--animated');
        } else if (elementOffsetTop <= trigger) {
          element.style.animationDelay = `${delay}ms`;
          element.style.transitionDelay = `${delay}ms`;
          element.classList.add('Animate--animated');

          delay += 50;
        }
      });
  });
};

export { animations };
